import React from 'react'
import { useHistory } from 'react-router-dom'
import { CHART_TYPES } from '../../mock'

export const ChartTypes = ({ setType, type, rewriteSelectedFiltersAction }) => {
  const onPress = (item) => {
    setType(item)
    rewriteSelectedFiltersAction({ key: 'type', value: item })
  }

  const history = useHistory()

  const PREFLOP_CHART_TYPES = {
    'GTO Tournament': 'mttsfullring',
    'CASH HU': 'preflop_hu_cash',
    'CASH 6max': 'preflop_6max_cash',
    'CASH 8max': 'preflop_8max_cash',
    'HU MTT - Small Ante': 'mttshunew',
    'HU MTT - 1bb Ante': 'mttshunew',
  }

  return (
    <div
    
      className="PreflopCharts__options"
    >
      <p>Chart types</p>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          width: '100%',
          rowGap: '10px',
        }}
      >
        {Object.entries(PREFLOP_CHART_TYPES).map(([label, value], idx) => {
          const isSelected = value === type
          return (
            <div
              key={value}
              onClick={() => {
                // actid=31
                window.analytics?.track("chart_type:click", {
                  "type": value
                });

                history.push(`/charts/gto?type=${value}`);
              }}
              className="PreflopCharts__button"
              style={{
                borderWidth: isSelected ? '2px' : 0,
              }}
            >
              <div
                className="PreflopCharts__button-label"
                style={{
                  color: isSelected ? '#0085FF' : 'black',
                }}
              >
                {label}
              </div>
            </div>
          )
        })}
        {Object.entries(CHART_TYPES).map(([value, label], idx) => {
          const isSelected = label === type
          return (
            <div
              key={value}
              onClick={() => {
                // actid=31
                window.analytics?.track("chart_type:click", {
                  "type": value
                });

                onPress(label);
              }}
              className="PreflopCharts__button"
              style={{
                borderWidth: isSelected ? '2px' : 0,
              }}
            >
              <div
                className="PreflopCharts__button-label"
                style={{
                  color: isSelected ? '#0085FF' : 'black',
                }}
              >
                {value}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
